import React from 'react';

/** Public asset — CRA serves files from /public at the site root. */
export const BOT_SRC = `${process.env.PUBLIC_URL || ''}/Bot.svg`;

/**
 * Fitted bot illustration (replaces lucide icons for AI surfaces).
 * Uses object-contain so the Canva export crops cleanly in a square frame.
 */
function BotAvatar({
  size = 36,
  className = '',
  alt = 'AI Assistant',
  decorative = false,
}) {
  const px = typeof size === 'number' ? size : undefined;
  return (
    <img
      src={BOT_SRC}
      alt={decorative ? '' : alt}
      aria-hidden={decorative ? true : undefined}
      draggable={false}
      className={`object-contain object-center select-none pointer-events-none ${className}`}
      style={px ? { width: px, height: px } : undefined}
    />
  );
}

export default BotAvatar;
